import React from 'react';
import icons from "../helpers/icons";
import Soesken from "./Soesken";
import Avkom from "./Avkom";
import TabLabel from "./TabLabel";
import StamtavleTre from './StamtavleTre';
import ElementHelp from './ElementHelp';
import Forfedre from "./Forfedre";
import qs from "query-string";
import {useHistory, withRouter} from "react-router-dom";


const Stamtavle = (props) => {
    let history = useHistory();
    const parsed = qs.parse(decodeURI(props.location.search));
    let tabId = 'tre';
    if (parsed.stamTab !== undefined) {
        tabId = parsed.stamTab;
    }

    const {hund, stamtavleTre, kull, helSoeskenValper, kullSammeMor, kullSammeFar, avkom, barnebarn, forfedre, sisteHunder, favoritter} = props;


    const setTabId = (t) => {
        let params = parsed;
        if (t !== tabId) {
            params.stamTab = t;
            if (t !== 'tre') {
                delete params.stamLabel;
            }
        }
        delete params.stamLabel;
        delete params.query;
        delete params.antall;
        const currentPath = props.location.pathname;
        history.push(currentPath + "?" + qs.stringify(params));
    };

    const antallSoesken = () => {
        var str = "";
        let antallSoesken = 0;
        antallSoesken = helSoeskenValper.length;
        for (let i = 0; i < helSoeskenValper.length; i++) {
            str += helSoeskenValper[i].hundId + ";"
        }

        for (let i = 0; i < kullSammeFar.length; i++) {
            for (let j = 0; j < kullSammeFar[i].valper.length; j++) {
                let key = kullSammeFar[i].valper[j].hundId + ";";
                if (str.indexOf(key) === -1) {
                    str += kullSammeFar[i].valper[j].hundId + ";"
                    antallSoesken++;
                }
            }
        }

        for (let i = 0; i < kullSammeMor.length; i++) {
            for (let j = 0; j < kullSammeMor[i].valper.length; j++) {
                let key = kullSammeMor[i].valper[j].hundId + ";";
                if (str.indexOf(key) === -1) {
                    str += kullSammeMor[i].valper[j].hundId + ";"
                    antallSoesken++;
                }
            }
        }
        return antallSoesken;

    };

    const totalAvkom = () => {
        let totalAvkom = 0;
        for (let i = 0; i < avkom.length; i++) {
            totalAvkom += avkom[i].valper.length;
        }
        return totalAvkom;
    };

    const renderComponent = () => {
        if (!forfedre) return null;
        switch (tabId) {
            case 'tre':
                return <StamtavleTre stamtavleTre={stamtavleTre} hund={hund} sisteHunder={sisteHunder} favoritter={favoritter}/>
            case 'far':
                return <Forfedre hund={forfedre.far} mor={forfedre.farmor} far={forfedre.farfar} labelHund={"FAR"} labelFar={"Farfar"} labelMor={"Farmor"} />
            case 'mor':
                return <Forfedre hund={forfedre.mor} mor={forfedre.mormor} far={forfedre.morfar} labelHund={"MOR"} labelFar={"Morfar"} labelMor={"Mormor"} />
            case 'soeskenede':
                return <Soesken hundId={hund.hundId}
                    kull={kull}
                    helSoeskenValper={helSoeskenValper}
                    kullSammeMor={kullSammeMor}
                    kullSammeFar={kullSammeFar}/>
            case 'afkom':
                return <Avkom antallKull={hund.antallKull} antallKullUnderBehandling={hund.antallKullUnderBehandling} avkom={avkom} barnebarn={barnebarn} />

            default:
                return null
        }
    };

    const renderTabTitelClass = (t) => {
        if (tabId === t) {
            return "tabs-title tab-active";
        }
        return "tabs-title";
    };

    return (
        <div className="dogweb-box">
            <div className="dogweb-card-header">
                <div className="card-title">STAMTAVLE </div>
                <div className="name-active-dog"> {hund.navn}</div>
                <ElementHelp slug={'stamtavle'}/>
            </div>
            <div className="tab-container">
                <ul className="tabs" id="pedigree">
                    <li className={renderTabTitelClass('tre')}>
                        <button onClick={() => setTabId("tre")} >
                            <span>
                                <img className="icon tree" src={icons.tree} alt="" />
                                <img className="icon treeWt" src={icons.treeWt} alt="" />
                            </span>
                        </button>
                    </li>
                    <li className={renderTabTitelClass('far')}>

                        <button onClick={() => setTabId("far")} >
                            <TabLabel name="FAR" />
                        </button>
                    </li>
                    <li className={renderTabTitelClass('mor')}>
                        <button onClick={() => setTabId("mor")} >
                            <TabLabel name="MOR" />
                        </button>
                    </li>
                    <li className={renderTabTitelClass('afkom')}>
                        <button onClick={() => setTabId("afkom")} >
                            <TabLabel name="AFKOM" count={totalAvkom()} />
                        </button>
                    </li>
                    <li className={renderTabTitelClass('soeskenede')}>
                        <button onClick={() => setTabId("soeskenede")} >
                            <TabLabel name="SØSKENDE" count={antallSoesken()} />
                        </button>
                    </li>

                </ul>

                <div className="tabs-panel is-active" >
                    {renderComponent()}
                </div>

            </div>

        </div>
    );
};



export default withRouter (Stamtavle);
